<h2 mat-dialog-title>Pontuação</h2>
<mat-dialog-content>
    <div>
        <form [formGroup]="form">
            <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Pontuação do candidato de 0 a 10</mat-label>
                    <input formControlName="points" matInput type="number" class="large" max="10" min="0" />
                </mat-form-field>
            </div>
        </form>
        <!-- <div style="text-align: center;">
            <p class="mat-body-2">Pontuação no filtro por palavra chave</p>
            <span class="mat-display-1">{{score}} pts</span>
        </div> -->
        <mat-divider></mat-divider>
        <br />
        <div style="text-align: center;" *ngIf="points">
            <p class="mat-body-2">Pontuação total</p>
            <span class="mat-display-1">{{totalScore()}} pts</span>
        </div>
    </div>

</mat-dialog-content>
<mat-progress-bar mode="indeterminate" *ngIf="submitting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submitting">
    <button mat-button mat-dialog-close color="accent">Fechar</button>
    <button mat-raised-button color="primary" (click)="submit()">Concluir</button>
</mat-dialog-actions>